import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GlobalState } from "../../../../GlobalState";
import { TabTitle } from "../../../../util/titleChanger";
import { api } from "../../../../util/urlConfig";
import "./productview.css";

function ProductView() {
  TabTitle("Product View");
  const { productId } = useParams();
  const state = useContext(GlobalState);

  const [productDetail] = state.productAPI.productDetail;
  const [users] = state.userAPI.users;
  const [id, setId] = state.productAPI.id;

  const [values, setValues] = useState("");

  useEffect(() => {
    if (productId > 0) {
      setId(productId);
      var today = new Date();

      var createAt = new Date(productDetail.created_at);
      var createBy =
        users.data && productDetail.created_by
          ? users.data.find((user) => {
              return user.nic === productDetail.created_by.nic;
            })
          : "";

      setValues({
        ...values,
        product_code: productDetail.product_code ? productDetail.product_code : "",
        name: productDetail.name ? productDetail.name : "",
        unit_type: productDetail.unit_type ? productDetail.unit_type : "",
        price: productDetail.price ? productDetail.price : "",
        description: productDetail.description ? productDetail.description : "",
        categoryName: productDetail.category ? productDetail.category.name : "",
        created_by: productDetail.created_by ? createBy : { first_name: "", last_name: "" },
        created_at: productDetail.created_at ? createAt.toLocaleDateString("ja-JP") : today.toLocaleDateString("ja-JP"),
        image_url: productDetail.upload_image ? api + "/" + productDetail.upload_image.image_url : "/img/dummy_avatar.png",
      });
    }
  }, [id, productId, productDetail]);
  return (
    <div className="profile-main-container">
      <div className="profile-container">
        <div className="left-container">
          <img src={values.image_url} alt="avatar" />
        </div>
        <div className="right-container">
          <div className="action">
            <Link to={`/product-form/${id}`}>
              <i className="uil uil-pen"></i>
              <button></button>
            </Link>
          </div>
          <div className="name-title">
            <h2>{values.name}</h2>
            <p>{values.product_code}</p>
          </div>
          <div className="user-content">
            <p>
              Unit Type : <span>{values.unit_type}</span>
            </p>
            <p>
              Price : <span>Rs. {values.price}.00</span>
            </p>
            <p className="status">
              Created By :{" "}
              <span>
                {values.created_by ? values.created_by.first_name : ""} {values.created_by ? values.created_by.last_name : ""}
              </span>
            </p>
            <p>
              Created At : <span>{values.created_at}</span>
            </p>
            <p>
              Description : <span>{values.description}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductView;
